export const READING_TASKS_DATA = {
  'poe-telltale-comprehension': {
    source: {
      author: 'Edgar Allan Poe',
      title: 'The Tell-Tale Heart',
      year: '1843',
      source: 'Classic American Literature'
    },
    passage: `True! --nervous --very, very dreadfully nervous I had been and am; but why will you say that I am mad? The disease had sharpened my senses --not destroyed --not dulled them. Above all was the sense of hearing acute. I heard all things in the heaven and in the earth. I heard many things in hell. How, then, am I mad? Hearken! and observe how healthily --how calmly I can tell you the whole story.

It is impossible to say how first the idea entered my brain; but once conceived, it haunted me day and night. Object there was none. Passion there was none. I loved the old man. He had never wronged me. He had never given me insult. For his gold I had no desire.

I think it was his eye! yes, it was this! He had the eye of a vulture --a pale blue eye, with a film over it. Whenever it fell upon me, my blood ran cold; and so by degrees --very gradually --I made up my mind to take the life of the old man, and thus rid myself of the eye forever.`,
    questions: [
      {
        id: 'q1',
        text: 'What sense does the narrator say was most acute?',
        options: ['hearing', 'sight', 'touch', 'smell'],
        correctAnswer: 'hearing'
      },
      {
        id: 'q2',
        text: 'Whom does the narrator say he loved?',
        options: ['the old man', 'his gold', 'his eye', 'his house'],
        correctAnswer: 'the old man'
      },
      {
        id: 'q3',
        text: 'What about the old man\'s eye bothered the narrator?',
        options: [
          'it was pale blue with a film',
          'it was bright green and sparkling',
          'it was red and bloodshot',
          'it was dark brown and calm'
        ],
        correctAnswer: 'it was pale blue with a film'
      },
      {
        id: 'q4',
        text: 'What did the narrator decide to do about the eye?',
        options: ['kill the old man', 'leave the house', 'ignore the eye', 'write about it'],
        correctAnswer: 'kill the old man'
      }
    ]
  },

  'ohenry-gift-magi': {
    source: {
      author: 'O. Henry',
      title: 'The Gift of the Magi',
      year: '1905',
      source: 'Classic American Literature'
    },
    passage: `One dollar and eighty-seven cents. That was all. And sixty cents of it was in pennies. Pennies saved one and two at a time by bulldozing the grocer and the vegetable man and the butcher until one's cheeks burned with the silent imputation of parsimony that such close dealing implied. Three times Della counted it. One dollar and eighty-seven cents. And the next day would be Christmas.

There was clearly nothing to do but flop down on the shabby little couch and howl. So Della did it. Which instigates the moral reflection that life is made up of sobs, sniffles, and smiles, with sniffles predominating.

While the mistress of the home is gradually subsiding from the first stage to the second, take a look at the home. A furnished flat at $8 per week. It did not exactly beggar description, but it certainly had that word on the lookout for the mendicancy squad.`,
    questions: [
      {
        id: 'q1',
        text: 'How much money did Della have?',
        options: ['one dollar and eighty-seven cents', 'two dollars', '$8', 'three dollars'],
        correctAnswer: 'one dollar and eighty-seven cents'
      },
      {
        id: 'q2',
        text: 'What did Della do after counting her money?',
        options: [
          'flopped down on the couch and howled',
          'went shopping',
          'called Jim',
          'took a nap'
        ],
        correctAnswer: 'flopped down on the couch and howled'
      },
      {
        id: 'q3',
        text: 'What was the rent for their apartment?',
        options: ['$8 per week', '$8 per month', '$8 per day', '$18 per week'],
        correctAnswer: '$8 per week'
      },
      {
        id: 'q4',
        text: 'What holiday was coming the next day?',
        options: ['Christmas', 'New Year\'s Day', 'Thanksgiving', 'Easter'],
        correctAnswer: 'Christmas'
      }
    ]
  },

  'dickens-christmas-carol': {
    source: {
      author: 'Charles Dickens',
      title: 'A Christmas Carol',
      year: '1843',
      source: 'Classic English Literature'
    },
    passage: `Marley was dead: to begin with. There is no doubt whatever about that. The register of his burial was signed by the clergyman, the clerk, the undertaker, and the chief mourner. Scrooge signed it: and Scrooge's name was good upon 'Change, for anything he chose to put his hand to. Old Marley was as dead as a door-nail.

Mind! I don't mean to say that I know, of my own knowledge, what there is particularly dead about a door-nail. I might have been inclined, myself, to regard a coffin-nail as the deadest piece of ironmongery in the trade. But the wisdom of our ancestors is in the simile; and my unhallowed hands shall not disturb it, or the Country's done for. You will therefore permit me to repeat, emphatically, that Marley was as dead as a door-nail.`,
    questions: [
      {
        id: 'q1',
        text: 'Who was dead at the beginning of the story?',
        options: ['Marley', 'Scrooge', 'the clerk', 'the chief mourner'],
        correctAnswer: 'Marley'
      },
      {
        id: 'q2',
        text: 'Which named character also signed the register of burial?',
        options: ['Scrooge', 'Marley', 'the clerk alone', 'no one'],
        correctAnswer: 'Scrooge'
      },
      {
        id: 'q3',
        text: 'What was Scrooge\'s reputation?',
        options: [
          'his name was good upon Change',
          'he was kind',
          'he was poor',
          'he was unknown'
        ],
        correctAnswer: 'his name was good upon Change'
      },
      {
        id: 'q4',
        text: 'What does the narrator say about door-nails?',
        options: [
          'he doesn\'t know what\'s particularly dead about them',
          'they are made of gold',
          'they are always new',
          'they are used for decorations'
        ],
        correctAnswer: 'he doesn\'t know what\'s particularly dead about them'
      }
    ]
  },

  'chekhov-lady-dog': {
    source: {
      author: 'Anton Chekhov',
      title: 'The Lady with the Dog',
      year: '1899',
      source: 'Classic Russian Literature'
    },
    passage: `It was said that a new person had appeared on the sea-front: a lady with a little dog. Dmitri Dmitritch Gurov, who had by then already spent two weeks in Yalta, and so was fairly at home there, had also become interested in new arrivals. Sitting in Verney's pavilion, he saw, walking on the sea-front, a young woman, not very tall, with a parasol, dressed in a light-colored dress. A white Pomeranian dog ran behind her.

Afterwards he met her in the public gardens and in the square several times a day. She was walking alone, always wearing the same dress, with the Pomeranian; no one knew who she was, and everyone called her simply "the lady with the little dog."

"If she's here alone without a husband or friends, it wouldn't be amiss to make her acquaintance," Gurov reflected.

He was under forty, but he had a daughter already twelve years old, and two sons at school. He had been married young, when he was still a student in his second year, and now his wife seemed to him half as old again as himself. She was a tall, erect woman with dark eyebrows, always dignified and imposing, and -- in his own words -- intellectual. She read a great deal, used abbreviations in her letters, and called her husband not Dmitri, but Dimitri; but he secretly considered her unintelligent, narrow, inelegant, was afraid of her, and did not like to be at home. He had begun deceiving her long ago -- he had been unfaithful to her often, and, probably for that reason, almost always spoke ill of women, and when they were discussed in his presence, he would say:

"The lower race."`,
    questions: [
      {
        id: 'q1',
        text: 'Where is the story set?',
        options: ['Yalta', 'Moscow', 'Paris', 'St. Petersburg'],
        correctAnswer: 'Yalta'
      },
      {
        id: 'q2',
        text: 'What kind of dog does the lady have?',
        options: ['Pomeranian', 'bulldog', 'terrier', 'beagle'],
        correctAnswer: 'Pomeranian'
      },
      {
        id: 'q3',
        text: 'How old is Gurov?',
        options: ['under forty', 'over fifty', 'in his twenties', 'about sixty'],
        correctAnswer: 'under forty'
      },
      {
        id: 'q4',
        text: 'What does Gurov think of his wife?',
        options: [
          'unintelligent and narrow',
          'kind and gentle',
          'adventurous',
          'he admires her'
        ],
        correctAnswer: 'unintelligent and narrow'
      }
    ]
  },

  'twain-tom-sawyer': {
    source: {
      author: 'Mark Twain',
      title: 'The Adventures of Tom Sawyer',
      year: '1876',
      source: 'Classic American Literature'
    },
    passage: `"TOM!"

No answer.

"TOM!"

No answer.

"What's gone with that boy, I wonder? You TOM!"

No answer.

The old lady pulled her spectacles down and looked over them about the room; then she put them up and looked out under them. She seldom or never looked through them for so small a thing as a boy; they were her state pair, the pride of her heart, and were built for "style," not service -- she could have seen through a pair of stove-lids just as well. She looked perplexed for a moment, and then said, not fiercely, but still loud enough for the furniture to hear:

"Well, I lay if I get hold of you I'll --"

She did not finish, for by this time she was bending down and punching under the bed with the broom, and so she needed breath to punctuate the punches with. She resurrected nothing but the cat.

"I never did see the beat of that boy!"

She went to the open door and stood in it and looked out among the tomato vines and "jimpson" weeds that constituted the garden. No Tom. So she lifted up her voice at an angle calculated for distance and shouted:

"Y-o-u-u TOM!"

There was a slight noise behind her and she turned just in time to seize a small boy by the slack of his roundabout and arrest his flight.

"There! I might 'a' thought of that closet. What you been doing in there?"

"Nothing."

"Nothing! Look at your hands. And look at your mouth. What is that truck?"

"I don't know, aunt."

"Well, I know. It's jam -- that's what it is. Forty times I've said if you didn't let that jam alone I'd skin you. Hand me that switch."

The switch hovered in the air -- the peril was desperate --`,
    questions: [
      {
        id: 'q1',
        text: 'Who is calling for Tom?',
        options: ['the old lady', 'the sheriff', 'Tom', 'the schoolmaster'],
        correctAnswer: 'the old lady'
      },
      {
        id: 'q2',
        text: 'Where does the old lady find Tom?',
        options: ['in the closet', 'in the garden', 'under the bed', 'in the attic'],
        correctAnswer: 'in the closet'
      },
      {
        id: 'q3',
        text: 'What does the old lady see around Tom\'s mouth?',
        options: ['jam', 'dirt', 'paint', 'blood'],
        correctAnswer: 'jam'
      },
      {
        id: 'q4',
        text: 'What does the old lady threaten to do?',
        options: ['switch him', 'send him to school', 'lock him out', 'give him candy'],
        correctAnswer: 'switch him'
      }
    ]
  }
  ,
  'poe-telltale-analysis-3': {
    source: {
      author: 'Edgar Allan Poe',
      title: 'The Tell-Tale Heart',
      year: '1843',
      source: 'Classic American Literature'
    },
    passage: `True! --nervous --very, very dreadfully nervous I had been and am; but why will you say that I am mad? The disease had sharpened my senses --not destroyed --not dulled them. Above all was the sense of hearing acute. I heard all things in the heaven and in the earth. I heard many things in hell. How, then, am I mad?

It is impossible to say how first the idea entered my brain; but once conceived, it haunted me day and night. Object there was none. Passion there was none. I loved the old man. He had never wronged me. He had never given me insult. For his gold I had no desire.

I think it was his eye! yes, it was this! He had the eye of a vulture --a pale blue eye, with a film over it. Whenever it fell upon me, my blood ran cold; and so by degrees --very gradually --I made up my mind to take the life of the old man, and thus rid myself of the eye forever.`,
    questions: [
      { id: 'q1', text: 'How does the narrator attempt to prove sanity?', options: ['by denying emotion', 'by emphasizing calm storytelling and sharpened senses', 'by presenting witness testimony', 'by admitting guilt immediately'], correctAnswer: 'by emphasizing calm storytelling and sharpened senses' },
      { id: 'q2', text: 'Which detail most strongly suggests unreliable narration?', options: ['he says he loved the old man', 'he heard things in hell', 'he mentions a pale blue eye', 'he speaks in first person'], correctAnswer: 'he heard things in hell' },
      { id: 'q3', text: 'What rhetorical effect is created by repeated dashes and exclamations?', options: ['formal distance', 'measured objectivity', 'agitated intensity', 'comic relief'], correctAnswer: 'agitated intensity' },
      { id: 'q4', text: 'The motive is best described as:', options: ['financial greed', 'revenge for insult', 'obsessive fixation', 'self-defense'], correctAnswer: 'obsessive fixation' },
      { id: 'q5', text: 'What tension drives the passage?', options: ['reason vs superstition', 'self-justification vs evidence of instability', 'poverty vs wealth', 'truth vs law'], correctAnswer: 'self-justification vs evidence of instability' },
      { id: 'q6', text: 'Why is the phrase "Object there was none. Passion there was none." significant?', options: ['it weakens dramatic pacing', 'it highlights the irrationality of the act', 'it identifies the legal motive', 'it introduces a second narrator'], correctAnswer: 'it highlights the irrationality of the act' },
      { id: 'q7', text: 'Which interpretation best fits "thus rid myself of the eye forever"?', options: ['literal medical treatment', 'symbolic rejection of judgment and paranoia', 'a metaphor for poverty', 'a confession of theft'], correctAnswer: 'symbolic rejection of judgment and paranoia' },
      { id: 'q8', text: 'The tone of the passage is most accurately:', options: ['detached and neutral', 'defensive and feverish', 'gentle and reflective', 'optimistic and calm'], correctAnswer: 'defensive and feverish' },
      { id: 'q9', text: 'What does the narrator’s insistence on logic paradoxically reveal?', options: ['stable objectivity', 'suppressed instability', 'historical accuracy', 'legal caution'], correctAnswer: 'suppressed instability' },
      { id: 'q10', text: 'Which theme is most central in this excerpt?', options: ['industrial change', 'obsession and self-deception', 'family loyalty', 'social mobility'], correctAnswer: 'obsession and self-deception' }
    ]
  },
  'dickens-christmas-carol-basic': {
    source: {
      author: 'Charles Dickens',
      title: 'A Christmas Carol',
      year: '1843',
      source: 'Classic English Literature'
    },
    passage: `Marley was dead: to begin with. There is no doubt whatever about that. The register of his burial was signed by the clergyman, the clerk, the undertaker, and the chief mourner. Scrooge signed it.

Old Marley was as dead as a door-nail. Mind! I don't mean to say that I know, of my own knowledge, what there is particularly dead about a door-nail.`,
    questions: [
      { id: 'q1', text: 'Who is definitely dead at the start?', options: ['Scrooge', 'Marley', 'the clerk', 'the narrator'], correctAnswer: 'Marley' },
      { id: 'q2', text: 'What document is mentioned as proof?', options: ['a marriage record', 'a letter', 'a burial register', 'a diary'], correctAnswer: 'a burial register' },
      { id: 'q3', text: 'Who signed the register according to the passage?', options: ['Marley', 'Scrooge', 'the chief mourner only', 'no one'], correctAnswer: 'Scrooge' },
      { id: 'q4', text: 'What comparison is used to stress Marley\'s condition?', options: ['dead as a stone', 'dead as a door-nail', 'dead as winter', 'dead as silence'], correctAnswer: 'dead as a door-nail' },
      { id: 'q5', text: 'How does the narrator sound when discussing the door-nail phrase?', options: ['strictly scientific', 'playfully self-aware', 'angry and harsh', 'confused and silent'], correctAnswer: 'playfully self-aware' }
    ]
  },
  'dickens-christmas-carol-advanced': {
    source: {
      author: 'Charles Dickens',
      title: 'A Christmas Carol',
      year: '1843',
      source: 'Classic English Literature'
    },
    passage: `Marley was dead: to begin with. There is no doubt whatever about that. The register of his burial was signed by the clergyman, the clerk, the undertaker, and the chief mourner. Scrooge signed it: and Scrooge's name was good upon 'Change, for anything he chose to put his hand to.

Mind! I don't mean to say that I know, of my own knowledge, what there is particularly dead about a door-nail. I might have been inclined, myself, to regard a coffin-nail as the deadest piece of ironmongery in the trade. But the wisdom of our ancestors is in the simile.`,
    questions: [
      { id: 'q1', text: 'Why does Dickens insist on Marley\'s death so forcefully?', options: ['to establish factual certainty before supernatural events', 'to praise legal records', 'to diminish Scrooge\'s role', 'to mock readers'], correctAnswer: 'to establish factual certainty before supernatural events' },
      { id: 'q2', text: 'What does "Scrooge\'s name was good upon \'Change" imply?', options: ['he was generous', 'he was financially credible and powerful', 'he was unknown', 'he was unemployed'], correctAnswer: 'he was financially credible and powerful' },
      { id: 'q3', text: 'The narrator\'s direct address ("Mind!") primarily creates:', options: ['distance from audience', 'an intimate conversational voice', 'legal authority', 'objective detachment'], correctAnswer: 'an intimate conversational voice' },
      { id: 'q4', text: 'What is the effect of discussing door-nails vs coffin-nails?', options: ['it weakens the opening', 'it introduces comic irony while reinforcing tradition', 'it changes the narrator', 'it shifts to tragedy'], correctAnswer: 'it introduces comic irony while reinforcing tradition' },
      { id: 'q5', text: 'The phrase "wisdom of our ancestors is in the simile" suggests Dickens values:', options: ['strict logic only', 'idiomatic tradition and shared language', 'scientific precision', 'economic arguments'], correctAnswer: 'idiomatic tradition and shared language' },
      { id: 'q6', text: 'Which best describes the opening style?', options: ['dry legal memorandum', 'blended certainty and playful narration', 'silent interior monologue', 'pure dialogue'], correctAnswer: 'blended certainty and playful narration' },
      { id: 'q7', text: 'Why list multiple signatories to the burial register?', options: ['to increase rhythm only', 'to create documentary credibility', 'to introduce villains', 'to delay plot'], correctAnswer: 'to create documentary credibility' },
      { id: 'q8', text: 'What tension appears in this passage?', options: ['fact vs superstition', 'war vs peace', 'city vs countryside', 'poverty vs abundance'], correctAnswer: 'fact vs superstition' },
      { id: 'q9', text: 'Why does Dickens use a conversational narrator at the opening?', options: ['to imitate legal writing', 'to build reader trust while controlling tone', 'to avoid plot movement', 'to reduce characterization'], correctAnswer: 'to build reader trust while controlling tone' },
      { id: 'q10', text: 'How does the opening most effectively prepare readers for later events?', options: ['by removing all ambiguity', 'by grounding the narrative in certainty before introducing the uncanny', 'by focusing only on economics', 'by presenting a courtroom scene'], correctAnswer: 'by grounding the narrative in certainty before introducing the uncanny' }
    ]
  },
  'chekhov-lady-dog-intermediate': {
    source: {
      author: 'Anton Chekhov',
      title: 'The Lady with the Dog',
      year: '1899',
      source: 'Classic Russian Literature'
    },
    passage: `It was said that a new person had appeared on the sea-front: a lady with a little dog. Dmitri Dmitritch Gurov, who had by then already spent two weeks in Yalta, had also become interested in new arrivals.

Afterwards he met her in the public gardens and in the square several times a day. She was walking alone, always wearing the same dress, with the Pomeranian; no one knew who she was, and everyone called her simply "the lady with the little dog."

"If she's here alone without a husband or friends, it wouldn't be amiss to make her acquaintance," Gurov reflected.`,
    questions: [
      { id: 'q1', text: 'Where does Gurov first notice the lady?', options: ['at a train station', 'on the sea-front', 'in a theater', 'at a market'], correctAnswer: 'on the sea-front' },
      { id: 'q2', text: 'How is the lady commonly identified?', options: ['by her husband', 'by her parasol', 'as the lady with the little dog', 'as a tourist guide'], correctAnswer: 'as the lady with the little dog' },
      { id: 'q3', text: 'What kind of dog accompanies her?', options: ['a beagle', 'a Pomeranian', 'a terrier', 'a spaniel'], correctAnswer: 'a Pomeranian' },
      { id: 'q4', text: 'What does repeated mention of her being alone suggest?', options: ['she is dangerous', 'she is socially visible yet mysterious', 'she is from Yalta', 'she dislikes animals'], correctAnswer: 'she is socially visible yet mysterious' },
      { id: 'q5', text: 'Why does Gurov want to meet her?', options: ['he needs directions', 'he is curious and attracted', 'he is helping police', 'he wants to sell something'], correctAnswer: 'he is curious and attracted' },
      { id: 'q6', text: 'Which tone best fits this excerpt?', options: ['violent and chaotic', 'quietly observant and suggestive', 'comic and absurd', 'formal and legal'], correctAnswer: 'quietly observant and suggestive' }
    ]
  },
  'chekhov-lady-dog-basic': {
    source: {
      author: 'Anton Chekhov',
      title: 'The Lady with the Dog',
      year: '1899',
      source: 'Classic Russian Literature'
    },
    passage: `A new person appeared on the sea-front: a lady with a little dog. Dmitri Gurov saw her walking with a white Pomeranian. No one knew her name, so people called her "the lady with the little dog."

Gurov noticed that she often walked alone in the gardens and square.`,
    questions: [
      { id: 'q1', text: 'Where did people see the lady?', options: ['at the station', 'on the sea-front', 'in a school', 'in a factory'], correctAnswer: 'on the sea-front' },
      { id: 'q2', text: 'What kind of dog was with her?', options: ['a Pomeranian', 'a beagle', 'a bulldog', 'a terrier'], correctAnswer: 'a Pomeranian' },
      { id: 'q3', text: 'Why did people call her "the lady with the little dog"?', options: ['they knew her family name', 'they did not know her name', 'she sold dogs', 'she was a teacher'], correctAnswer: 'they did not know her name' },
      { id: 'q4', text: 'Who noticed her in the passage?', options: ['Scrooge', 'Tom Sawyer', 'Gurov', 'Poe'], correctAnswer: 'Gurov' },
      { id: 'q5', text: 'How is the lady often described in this excerpt?', options: ['walking alone', 'speaking loudly', 'traveling with friends', 'working at a shop'], correctAnswer: 'walking alone' }
    ]
  }
};
